// Centralized revision types for entity versioning
// Use these instead of string literals

export const REV_TYPES = Object.freeze({
  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
})

export default REV_TYPES
